import {
  GET_SPECIFIC_NEWS,

  START_NEWS_LOADING,
  STOP_NEWS_LOADING,
  GET_NEWS,
  GET_NEWS_ERROR,
  SET_NEWS_PAGE,
  SET_FILTER_TYPE,
  CLEAR_NEWS,
  START_TOPICS_LOADING,
  STOP_TOPICS_LOADING,
  GET_TOPICS,
  GET_NEWS_BY_TOPIC,
} from "../types";

import { dummyNewsData } from "../dummydata";
const NewsReducer = (state, action) => {
  switch (action.type) {
    case GET_SPECIFIC_NEWS:
      return {
        ...state,
        specificNews: action.payload.data.newsData,
        sentimentData:
          action.payload.data.sentimentData &&
          action.payload.data.sentimentData.length > 0 &&
          action.payload.data.sentimentData,
        news:
          state.news && state.news.length > 0 ? state.news.slice(0, 5) : null,
      };
    case GET_NEWS:
      return {
        ...state,
        news:
          action.ctype === "single"
            ? action.payload?.data && action.payload.data
            : action.payload?.data &&
              state.news &&
              state.news.length > 0 &&
              state.news[0]._id
            ? [...state.news, ...action.payload.data]
            : action.payload?.data && action.payload.data,
        topicNews: null,
      };
    case CLEAR_NEWS:
      return { ...state, news: null, topicNews: null };
    case GET_NEWS_ERROR:
      return { state, newsError: action.payload };
    case START_NEWS_LOADING:
      return {
        ...state,
        newsLoading: true,

      };
    case SET_FILTER_TYPE:
      return { ...state, filterType: action.payload };
    case SET_NEWS_PAGE:
      return {
        ...state,
        newsPage: action.payload,
      };
    case STOP_NEWS_LOADING:
      return { ...state, newsLoading: false };

    case GET_TOPICS:
      return {
        ...state,
        topics: action.payload.success ? action.payload.data : null,
      };
    case START_TOPICS_LOADING:
      return { ...state, topicsLoading: true };
    case STOP_TOPICS_LOADING:
      return { ...state, topicsLoading: false };
    case GET_NEWS_BY_TOPIC:
      return {
        ...state,
        topicNews:
          action.payload?.data && state.topicNews && state.topicNews.length > 0
            ? [...state.topicNews, ...action.payload.data]
            : action.payload?.data && action.payload.data,
        news: null,
      };
    default:
      return { ...state };
  }
};

export default NewsReducer;

// action.ctype === "single"
// ? action.payload.data.slice(0, 5):

// : state.news && state.news.length > 0 && state.news[0]._id
// ? [...state.news, ...action.payload.data]
// : action.payload.data,
